import React from 'react';
import { useDispatch } from 'react-redux';

import './SubcategoriesSearch.css';
import { AppService } from '../../../services/app.service';
import { AppActionEnum } from '../../../enums/app-action.enum';
import { useCurrentVerticalData } from '../../../hooks/use-current-vertical-data.hook';
import { GtmService } from '../../../services/gtm.service';
import {
    GtmEventLocation,
    GtmEventComponent,
    GtmEventClickElement
} from '../../google-tag-manager/enums/gtm-event-enum';

export const SubcategoriesSearch = () => {
    const dispatch = useDispatch();

    const {
        pamGameVerticalID,
        currentVerticalType,
    } = useCurrentVerticalData();

    const trackSearch = () => {
        GtmService.track({
            location: GtmEventLocation.GAME_GRID,
            component: GtmEventComponent.GAMES_CATEGORIES,
            click_element: GtmEventClickElement.BUTTON,
            click_action: 'subcategories search',
            game_vertical_id: pamGameVerticalID,
            game_vertical_type: currentVerticalType,
        });
    };

    const ctaHandler = (actionId, actionTarget) => {
        AppService.ctaHandler(actionId, actionTarget, dispatch);
    };
    const handleSearchOpen = () => {
        trackSearch();
        ctaHandler(AppActionEnum.SET_IS_LEFT_MENU_OPEN, true);
        ctaHandler(AppActionEnum.SET_IS_MOBILE_SEARCH_OPEN, true);
    };

    return (
        <div className="subcategories-search-container">
            <div
                className="subcategories-search-container__search-btn"
                onClick={handleSearchOpen}
            >
                <div className="subcategories-search-container__search-btn-icon"></div>
            </div>
        </div>
    );
};
